import _ from "lodash";
import { getOrgs } from 'db';
import { SHOW_ALERT } from './ui';
import { ORG_STATUS } from "constants/org";
import { auth } from "helpers/firebase";

export const ORG_CREATED = 'org_created';
export const ORGS_FETCHED = 'org_fetched';
export const SELECT_CURRENT_ORG = 'select current org';

export const createOrgAction = (params) => {
  // createOrg()
}

export const getOrgsAction = () => (dispatch, getState) => {
  const { currentRole } = getState().auth;
  if (!currentRole) {
    return null;
  }
  return getOrgs(currentRole)
    .then(orgs => {
      const last_selected_org_id = localStorage.getItem('last_selected_org_id');
      const org = last_selected_org_id
        ? _.find(orgs, org => org.id === last_selected_org_id)
        : null;

      if (org) {
        dispatch(selectCurrentOrgAction(org));
      } else {
        if (orgs.length > 0) {
          dispatch(selectCurrentOrgAction(orgs[0]));
        }
      }
      return dispatch({
        type: ORGS_FETCHED,
        payload: orgs
      });
    })
    .catch(e => {
      const message = e.code === 'permission-denied'
        ? '권한이 없습니다. 관리자에게 문의해주세요.'
        : `에러가 발생했습니다. ${e.message}`
      return dispatch({
        type: SHOW_ALERT,
        payload: {
          message,
          color: 'danger',
        }
      })
    })
}

export const selectCurrentOrgAction = (org) => (dispatch) => {
  console.log("org = ", org.data());
  const { status = ORG_STATUS.WAITING_FOR_REVIEW } = org.data();
  switch (status) {
    case ORG_STATUS.WAITING_FOR_REVIEW:
      alert('현재 기관이 검토 대기중입니다. 검토 후에 승인이 나면 이용이 가능합니다.');
      break;
    case ORG_STATUS.IN_REVIEW:
      alert("현재 기관에 대해서 검토중입니다. 검토후에 승인이 나면 이용이 가능합니다.");
      break;
    case ORG_STATUS.REJECTED:
      alert("기관에 대한 검토 결과 거부되었습니다. 재검토를 요청하시려면 관리자에게 문의해주세요.");
      break;
    case ORG_STATUS.REMOVED:
      alert("소속된 기관이 삭제되었습니다. 관리자에게 문의해주세요.");
      break;
    case ORG_STATUS.ASSOCIATE_MEMBER:
    case ORG_STATUS.REGULAR_MEMBER:
      dispatch({
        type: SELECT_CURRENT_ORG,
        payload: org
      })
      localStorage.setItem('last_selected_org_id', org.id);
      break;
    default:
      alert("소속 기관의 상태값이 비정상입니다. 관리자에게 문의해주세요.");
  }
}